<script lang="ts">
    import { _ } from "svelte-i18n"
    import { fly } from "svelte/transition"
    import { clickOutside } from "../../utils"
    import MagnifyIcon from "svelte-material-icons/Magnify.svelte"
    import { mobileSearchOverlay } from "../../store"
    import { navigate } from "../../../../vendor/svelte-routing"

    let search: string
</script>

<div
    class="search_overlay"
    transition:fly="{{ x: 1000 }}"
    use:clickOutside="{(target) => {
        if (!document.getElementById('searchIconLink').contains(target)) $mobileSearchOverlay = false
    }}"
>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <!--
    <a
        class="search_closer"
        href=""
        on:click|preventDefault="{() => {
            $mobileSearchOverlay = false
        }}"
    >
        <ArrowRightIcon />
        <span class="text">schließen</span>
    </a>
    -->

    <div class="headline">{$_("mobile-search.headline")}</div>
    <form
        class="form"
        on:submit|preventDefault="{() => {
            navigate('/search?' + encodeURIComponent(search))
            $mobileSearchOverlay = false
        }}"
    >
        <div class="input_holder">
            <input
                type="text"
                name="search"
                placeholder="{$_('mobile-search.placeholder')}"
                bind:value="{search}"
                required
            />
            <button type="submit" class="searchicon btn btn-secondary">
                <MagnifyIcon />
            </button>
        </div>
    </form>
</div>

<style lang="less">
    @import "../../css/variables.less";
    .search_overlay :global {
        background: var(--surface-3);
        color: var(--on-surface-3);
        position: fixed;
        top: var(--navheight_mobile);
        @media (min-width: @res-desktop) {
            top: var(--navheight);
        }
        left: 0px;
        right: 0px;
        bottom: 0px;
        width: 100vw;
        display: block;
        z-index: 2000;
        .flex();
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .headline {
            margin-bottom: 20px;
        }
        .form {
            width: 80%;
            button {
                width: 100%;
                .flex();
                align-items: center;
                justify-content: center;
            }
        }
        @media @tablet {
            max-width: 600px;
            left: inherit;
        }
        .search_closer {
            background: var(--background);
            .flex();
            align-items: center;
            border-bottom: 1px solid var(--border-color-default);
            padding: 3px 20px;
            margin-bottom: 20px;
            font-size: 18px;
        }
    }
</style>
